<template>
  <div>
    <v-app-bar app color="dark-grey" dark clipped-left>
    <v-app-bar-nav-icon v-if="isLoggedIn" @click="$emit('update:showNavDrawer', !showNavDrawer)"/>
   
    <v-toolbar-title>
      {{ $store.getters.BANK_TITLE }}
    </v-toolbar-title> 
    <v-img
      v-if="
        $store.getters.BANK_ICON !== '' &&
        $store.getters.BANK_ICON !== null &&
        $store.getters.BANK_ICON !== undefined
      "
      class="mx-auto bank-icon ml-4"
      :src="$store.getters.BANK_ICON"
      @click="handle3Clicks"
      max-width="25"
      max-height="20"
    />
    
    <v-spacer></v-spacer>
    <template v-if="isLoggedIn">
      <span>
        {{ $t("referenceBooks.users.UserName") }} : {{ username }}
      </span>

      <div class="icons">
        <LogoutButton @hidePasswordForm="$emit('update:showPasswordForm', false);"/>
        <ServiceStatusButton v-if="$store.getters.CAN_SEE_SERVICE_STATUSES" />
        <PasswordButton />
        <InactionTimeButton v-if="$store.getters.CAN_SEE_USERS" />
        <TechadressButton v-if="$store.getters.CAN_SEE_USERS" />
        <SettingsButton />
      </div>
    </template>
    </v-app-bar>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LogoutButton from './LogoutButton.vue';
import ServiceStatusButton from './ServiceStatusButton.vue';
import PasswordButton from './PasswordButton.vue';
import InactionTimeButton from './InactionTimeButton.vue';
import SettingsButton from './SettingsButton.vue';
import TechadressButton from './TechadressButton.vue';

export default {
  name: 'AppBar',
  components: {
    LogoutButton,
    ServiceStatusButton,
    PasswordButton,
    InactionTimeButton,
    SettingsButton,
    TechadressButton
  },
  props: {
    showPasswordForm: Boolean,
    showNavDrawer: Boolean,
  },
  data: () => ({
    fab: false,
    direction: 'right',
    counter: 0,
    deftimeBeforeLogout: 10,
    timeBeforeLogout: 10,
    bankIcon: '',
    clickCount: 0,
    clickTimeout: null
  }),
  async mounted() {
    this.bankIcon = this.$store.getters.BANK_ICON;
    this.runExitTimer();
  },
  computed: {
    ...mapState(['token', 'status']),
    ...mapGetters(['isLoggedIn']),
    banks() {
      return this.$store.state.banks;
    },
    userRights() {
      return this.$store.state.userRights;
    },
    username() {
      return this.$store.getters.USERNAME;
    },
  },
  created: function() {
    if (this.token) {
      this.$store.dispatch('getUserData', { vm: this }).catch(() => {
        this.$router.push({ path: '/login' });
      });
    }
  },
  methods: {
    runExitTimer() {
      this.$localStorageObj.setLogoutCounterScale(Date.now(), this.username);
      document.addEventListener('mousemove', () => {
        this.$localStorageObj.setLogoutCounterScale(Date.now(), this.username);
      });
      document.addEventListener('keydown', () => {
        this.$localStorageObj.setLogoutCounterScale(Date.now(), this.username);
      });
      document.addEventListener('mouseclick', () => {
        this.$localStorageObj.setLogoutCounterScale(Date.now(), this.username);
      });
      setInterval(() => {
        const currentCounter = this.$localStorageObj.getLogoutCounterByUser(
          this.username
        );
        if (currentCounter > 0) {
          this.$localStorageObj.setLogoutCounterScale(currentCounter - 1, this.username);
        }
        else if (currentCounter <= 0 && this.$store.getters.isLoggedIn) {
          this.$store.dispatch('logout', {vm: this}).then(() => {
            this.$router.push('/login');
          });
        }
        const timeout = this.$store.getters.TIMEOUT;
        if (this.$store.getters.isLoggedIn && Date.now() - currentCounter > timeout * 60 * 1000) {
          this.$store.dispatch('logout', { vm: this }).then(() => {
            this.$router.push('/login');
          });
        }
      }, 1000 * 60);
    },
    handle3Clicks() {
      this.clickCount++;

      if (this.clickCount === 1) {
        this.clickTimeout = setTimeout(() => {
          this.clickCount = 0;
        }, 3000);
      }

      if (this.clickCount === 3) {
        this.$emit('update:showPasswordForm', true);
        clearTimeout(this.clickTimeout);
        this.clickCount = 0; 
      } 
    },
  }
};
</script>

<style>
  .bank-icon {
    margin: 0;
    max-width: 25px;   
    max-height: 20px;   
  }
  .icons {
    display: flex;
  }

</style>
